// src/pages/SignIn.jsx
import React from "react";
import { useForm } from "react-hook-form";
import InputField from "components/fields/InputField";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginAsync } from "store/authSlice";
import LoaderButton from "components/button/LoaderButton";

export default function SignIn() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error } = useSelector((state) => state.auth);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { identifier: "", password: "" },
    mode: "onBlur",
  });

  const emailRegex = /^\S+@\S+$/i;
  const mobileRegex = /^[0-9]{10}$/;

  const onSubmit = async ({ identifier, password }) => {
    // Build payload expected by your backend
    const payload = emailRegex.test(identifier)
      ? { email_or_mobile: identifier, password }
      : { email_or_mobile: identifier, password };

    const res = await dispatch(loginAsync(payload));
    if (loginAsync.fulfilled.match(res)) {
      navigate("/dashboard");
    }
  };

  return (
    <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className=" w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your email or mobile and password to sign in!
        </p>

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          {/* Email or Mobile */}
          <InputField
            variant="auth"
            extra="mb-3"
            label="Email or Mobile*"
            placeholder="Enter email or 10-digit mobile number"
            id="identifier"
            type="text"
            autoComplete="username"
            error={errors.identifier}
            {...register("identifier", {
              required: "Email or mobile is required",
              validate: (value) => {
                if (emailRegex.test(value) || mobileRegex.test(value))
                  return true;
                return "Enter a valid email or 10-digit mobile number";
              },
            })}
          />

          {/* Password */}
          <InputField
            variant="auth"
            extra="mb-3"
            label="Password*"
            placeholder="Min. 8 characters"
            id="password"
            type="password"
            autoComplete="current-password"
            error={errors.password}
            {...register("password", {
              required: "Password is required",
              minLength: {
                value: 8,
                message: "At least 8 characters required",
              },
            })}
          />

          {/* Links row */}
          <div className="mt-6 flex items-center justify-center">
            <LoaderButton
              type="submit"
              isLoading={loading}
              className="w-full !py-2 !text-base"
            >
              Sign In
            </LoaderButton>
          </div>
          {error && (
            <p className="mt-3 text-center text-sm text-red-500">
              {typeof error === "string" ? error : "Sign in failed"}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
